const STORAGE_KEY = 'admin_token';

export function setAdminSession(token) {
  localStorage.setItem(STORAGE_KEY, token);
}

export function getAdminToken() {
  return localStorage.getItem(STORAGE_KEY);
}

export function adminLogout() {
  localStorage.removeItem(STORAGE_KEY);
}

export function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export function isAdminLoggedIn() {
  const token = getAdminToken();
  if (!token) return false;
  const payload = parseJwt(token);
  if (!payload || payload.role !== 'admin') return false;
  if (payload.exp && payload.exp * 1000 < Date.now()) return false;
  return true;
}

export async function adminFetch(url, options = {}) {
  const token = getAdminToken();
  // Don't force a JSON Content-Type for FormData bodies — the browser must set
  // its own `multipart/form-data; boundary=...` header, otherwise the server
  // (multer) can't parse the upload.
  const isFormData = options.body instanceof FormData;
  return fetch(url, {
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });
}
